/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} My_Integrations_Disconnect_Confirm_DescriptionInputs */



/**
* | output |
* | --- |
* | "{name} will stop working and the assistant will lose access to it. You can connect it again afterwards." |
*
* @param {My_Integrations_Disconnect_Confirm_DescriptionInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const my_integrations_disconnect_confirm_description = /** @type {((inputs: My_Integrations_Disconnect_Confirm_DescriptionInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<My_Integrations_Disconnect_Confirm_DescriptionInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.name} funktioniert dann nicht mehr und der Assistent verliert den Zugriff. Sie können die Verbindung später erneut herstellen.`)
	return /** @type {LocalizedString} */ (`${i?.name} will stop working and the assistant will lose access to it. You can connect it again afterwards.`)
});